// Format helpers

export const naira = (amount) => {
  if (amount === null || amount === undefined || amount === "") return "₦—";
  const n = Number(amount);
  if (Number.isNaN(n)) return "₦—";
  return "₦" + n.toLocaleString("en-NG");
};

export const formatDate = (iso) => {
  if (!iso) return "—";
  try {
    const d = new Date(iso);
    return d.toLocaleDateString("en-NG", { day: "2-digit", month: "short", year: "numeric" });
  } catch { return iso; }
};

export const formatDateTime = (iso) => {
  if (!iso) return "—";
  try {
    const d = new Date(iso);
    return d.toLocaleString("en-NG", { day: "2-digit", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit" });
  } catch { return iso; }
};

export const daysBetween = (a, b) => {
  if (!a || !b) return 0;
  const ms = new Date(b) - new Date(a);
  return Math.ceil(ms / 86400000);
};

export const formatApiError = (err) => {
  const d = err?.response?.data?.detail;
  if (!d) return err?.message || "Something went wrong";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map(e => e?.msg || JSON.stringify(e)).join(" ");
  if (d?.msg) return d.msg;
  return String(d);
};

export const statusBadgeClass = (status) => {
  const s = (status || "").toLowerCase();
  if (["paid", "active", "occupied", "completed", "approved"].includes(s)) return "badge badge-green";
  if (["pending", "renewal_due", "renewal", "pending_onboarding", "sent_to_tenant", "draft", "tenant_signed", "manager_signed", "lawyer_signed", "assigned", "in_progress"].includes(s)) return "badge badge-gold";
  if (["overdue", "vacant", "failed", "cancelled", "urgent", "high"].includes(s)) return "badge badge-red";
  if (["archived", "renewed", "closed", "expired", "disabled"].includes(s)) return "badge badge-gray";
  if (["under_maintenance"].includes(s)) return "badge badge-blue";
  return "badge badge-gray";
};

export const statusLabel = (status) => {
  if (!status) return "—";
  return String(status).replace(/_/g, " ").replace(/\b\w/g, c => c.toUpperCase());
};

export const roleLabel = (role) => {
  const labels = { admin: "Admin / Landlord", manager: "Property Manager", lawyer: "Legal Officer", tenant: "Tenant", maintenance: "Maintenance Staff" };
  return labels[role] || role;
};

export const roleHome = (role) => {
  const h = { admin: "/admin", manager: "/manager", lawyer: "/legal", tenant: "/tenant", maintenance: "/maintenance" };
  return h[role] || "/login";
};
